import React, { useEffect, useState } from 'react'

export const ChuGiaiChatLuongDat = (props) => {
    const [listChuGiais, setListChuGiai] = useState([]);
    useEffect(() => {
        setListChuGiai(props.listChuGiais);
    }, [props.listChuGiais]);
    const clickRow = (item) => {
        item.Checked = !item.Checked;
        setListChuGiai([...listChuGiais]);
        props.clickChuGiai(listChuGiais.filter(x => x.Checked).map(x => "'" + x.dvdd_h + "'").join(','));
    }
    return (
        <table className="table table-bordered tb-chu-giai" width="100%">
            <thead>
                <tr>
                    <th rowSpan="2" className="col-checkbox"></th>
                    <th rowSpan="2" className="mau-ky-hieu">Màu sắc Ký hiệu</th>
                    <th colSpan="8">ĐẶC TÍNH ĐƠN VỊ ĐẤT ĐAI</th>
                </tr>
                <tr>
                    <th>Chế độ tưới</th>
                    <th>Độ dốc</th>
                    <th>Mức độ đá lẫn</th>
                    <th>Độ dày tầng đất</th>
                    <th>Thành phần cơ giới</th>
                    <th>Độ phì</th>
                </tr>
            </thead>
            <tbody>
                {
                    listChuGiais?.map((item, key) => {
                        return (
                            <tr onClick={() => clickRow(item)} key={key}>
                                <td className="col-checkbox">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" checked={item.Checked} readOnly />
                                    </div>
                                </td>
                                <td className="mau-ky-hieu">
                                    <div style={{ backgroundColor: item.image }}>
                                        <span>{item.dvdd_h}</span>
                                    </div>
                                </td>
                                <td>{item.phancaptuoi}</td>
                                <td>{item.phancapdoc}</td>
                                <td>{item.phancapdalan}</td>
                                <td>{item.phancapdoday}</td>
                                <td>{item.phancaptpcg}</td>
                                <td>{item.phancapfe}</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </table>
    )
}
